export default __webpack_public_path__ + "static/media/newresonance_img.0abc624e.png";